import {
  RiHome4Line,
  RiFileCopyLine,
  RiFileCopy2Line,
  RiFileEditLine,
  RiLockPasswordLine,
  RiEarthLine,
  RiCalculatorLine,
} from "react-icons/ri";
import { AiOutlineInfoCircle } from "react-icons/ai";
export const Links = [
  {
    name: "Tableau de bord",
    path: "/",
    Icon: RiHome4Line,
  },
  {
    name: "Situation globale",
    path: "/global-situation",
    Icon: RiEarthLine,
  },
  // {
  //   name: "Loyer du mois à payer",
  //   path: "/month-rent",
  //   Icon: RiMoneyDollarBoxLine,
  // },
  {
    name: "Etat des loyers non réglés",
    path: "/unpaid-rent",
    Icon: RiFileCopyLine,
  },
  {
    name: "Edition des factures",
    path: "/invoice-editing",
    Icon: RiFileEditLine,
  },
  // {
  //   name: "Liste des Contrats vivants",
  //   path: "/living-contracts",
  //   Icon: RiFileCopyLine,
  // },
  {
    name: "Etat des financements en cours",
    path: "/outstandings",
    Icon: RiFileCopy2Line,
  },
  {
    name: "Demandes de modification de l’assurance",
    path: "/list-insurance-requests",
    Icon: RiFileEditLine,
  },
  {
    name: "Demandes d'autorisation de quitter le territoire",
    path: "/list-authorization-leave-territory",
    Icon: RiFileEditLine,
  },
  {
    name: "Demandes de mainlevée",
    path: "/release-requests",
    Icon: RiFileEditLine,
  },
  // {
  //   name: "Simulations",
  //   path: "/list-simulations",
  //   Icon: RiCalculatorLine,
  //   disbled: false,
  // },
  {
    name: "Simulations & Demande de financement",
    path: "/list-financing-request",
    Icon: RiFileEditLine,
  },
];

export const Bottom_Links = [
  {
    name: "Réclamation",
    path: "/list-claim",
    Icon: AiOutlineInfoCircle,
  },
  {
    name: "Demande de prise de RDV",
    path: "/add-contact",
    Icon: RiFileEditLine,
  },
];

export const ProfileFirstConnect = [
  {
    name: "Modifier mot de passe",
    path: "/edit-account",
    Icon: RiLockPasswordLine,
  },
];
